import React, { memo, SVGProps } from 'react'

export const Minus = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 12.2577C4.5 11.8434 4.83579 11.5077 5.25 11.5077L18.75 11.5077C19.1642 11.5077 19.5 11.8434 19.5 12.2577C19.5 12.6719 19.1642 13.0077 18.75 13.0077H5.25C4.83579 13.0077 4.5 12.6719 4.5 12.2577Z"
      fill="currentColor"
    />
  </svg>
))
